import { queryOptions, useQuery } from '@tanstack/react-query';

import type {
  FamilyContactWithParent,
  FamilyDocument,
} from '~entities/family/model/family.type';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export type FamilyByParentResponse = {
  family: FamilyDocument | null;
  contacts: FamilyContactWithParent[];
};

export const getFamilyByParent = async (parentId: string) => {
  const response = await baseAPI.get<FamilyByParentResponse>(
    `/v2/families/by-parent/${parentId}`,
  );
  return response.data;
};

export const getFamilyByParentOptions = (parentId?: string) =>
  queryOptions({
    queryKey: [KEYS.FAMILY_BY_PARENT, parentId],
    queryFn: () => getFamilyByParent(parentId!),
    staleTime: 1000 * 60 * 2,
    enabled: !!parentId,
  });

export const useGetFamilyByParent = (parentId?: string) => {
  return useQuery(getFamilyByParentOptions(parentId));
};
